export default __webpack_public_path__ + "static/media/warehousepic2.23476514.jpg";